import {PayloadAction} from "../payload-action.interface";
import {LocationEntity} from "./location.entity";


export class LocationActions{
  static readonly ADD 		  = '[LocationActions] ADD';
  static readonly ADD_ALL 	= '[LocationActions] ADD_ALL';
  static readonly REMOVE 		= '[LocationActions] REMOVE';
  static readonly SET 		  = '[LocationActions] SET';

  static addAll(locations: Array<LocationEntity>): PayloadAction{
    return {
      type: LocationActions.ADD_ALL,
      payload: locations
    }
  }

  static add(location: LocationEntity): PayloadAction{
    return {
      type: LocationActions.ADD,
      payload: location
    }
  }

  static set(location: LocationEntity): PayloadAction{

    return {
      type: LocationActions.SET,
      payload: location
    }
  }

  static remove(id: string): PayloadAction{
    return {
      type: LocationActions.REMOVE,
      payload: id
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/location/location.actions.ts